<script lang="ts">
	import { AutoComplete, Card, Pagenation } from "@hitit/new_ui";
	import { t, api } from "@hitit/hub/src/stores";
	import ComponentLoading from "../components/common/ComponentLoading.svelte";
	import UserListRow from "../components/earning/UserListRow.svelte";
	import UserUseList from "../components/earning/UserUseList.svelte";
	import { Cach } from "@hitit/hub/src/v7/class/index";
	import { GetUserSortType, type StoreUserMinDTO } from "@hitit/api";
	import { getInternationalPhonenumber } from "../../functions/utils/phone";
	import { onDestroy } from "svelte";
	import { popup } from "../store";
	export let storeId = "";

	let search = "";
	let bindingSearch = "";
	let isLoading = false;
	let totalUserCount = 0;
	let presentPage = 0;
	let maxpage = presentPage;
	let userList: StoreUserMinDTO[] = [];

	let openStatus = new Cach();

	async function autocompleteHandler(search: string) {
		const { data } = await $api.searchUserInStore(
			storeId,
			0,
			GetUserSortType.CELLNUM_ASC,
			getInternationalPhonenumber(search, "82")
		);

		return data.storeUserMinDTOs.map((v) => {
			return {
				name: v.userIdentity,
				callback: () => {
					totalUserCount = 1;
					presentPage = 0;
					maxpage = 0;
					userList = [v];
				},
			};
		});
	}

	async function getCustomerList(
		_storeId: string,
		userId: string,
		_page: number,
		sort: GetUserSortType
	) {
		try {
			isLoading = true;

			const { data } = await $api.searchUserInStore(
				_storeId,
				_page,
				sort,
				getInternationalPhonenumber(userId, "82")
			);
			if (_storeId !== storeId || _page !== presentPage) {
				return;
			}

			maxpage = data.totalPages;
			totalUserCount = data.totalElements;
			userList = data.storeUserMinDTOs;
		} catch (error) {
			console.log(error);
		} finally {
			isLoading = false;
		}
	}

	async function submitHandler() {
		search = bindingSearch;
		presentPage = 0;
		await getCustomerList(storeId, search, 0, GetUserSortType.CELLNUM_ASC);
	}

	async function buttonHandler(_page: number) {
		presentPage = _page;
		console.log(presentPage);
		await getCustomerList(storeId, search, _page, GetUserSortType.CELLNUM_ASC);
	}

	function rowHandler(id: string) {
		if (openStatus.getCach(`${storeId}_${id}`)) {
			const cached = openStatus.getCach(`${storeId}_${id}`);
			cached.open = !cached.open;
			openStatus = openStatus;
		} else {
			const cached = {
				open: true,
			};
			openStatus.setCach(`${storeId}_${id}`, cached);
			openStatus = openStatus;
		}
	}

	$: totalPeople = ((total: number) => {
		const template = $t("global.total_x_people", "100");
		return template.replaceAll("{count}", `${total}`);
	})(totalUserCount);

	//React by storeId
	$: ((_) => {
		search = "";
		presentPage = 0;
		maxpage = 0;
		totalUserCount = 0;
	})(storeId);

	//React by Store id
	$: ((storeId) => {
		getCustomerList(storeId, "", 0, GetUserSortType.CELLNUM_ASC);
	})(storeId);

	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	<div class="search">
		<form on:submit|preventDefault={submitHandler}>
			<AutoComplete
				bind:search={bindingSearch}
				placeholder={$t('mbr.point.Phone_number_search')}
				searchCallback={autocompleteHandler} />
			<button class="hidden" />
		</form>
	</div>

	<Card noPadding>
		<div class="table-container">
			{#if isLoading}
				<ComponentLoading coverMode />
			{/if}
			<p id="total-count">{totalPeople}</p>
			<div class="table">
				<div class="header">
					<div class="phone col">{$t('global.customerInfo.phone')}</div>
					<div class="create col">{$t('global.customerInfo.createdDate')}</div>
					<div class="current col">
						{$t('global.customerInfo.activateTotalPoint')}
					</div>
					<div class="accumulate col">
						{$t('global.customerInfo.totalPoint')}
					</div>
					<div class="used col">{$t('global.customerInfo.usedPoint')}</div>
				</div>
				<div class="body">
					{#each userList as user, index}
						<UserListRow
							on:click={() => rowHandler(user.id)}
							user={user}
							borderBottom={userList.length - 1 !== index && !openStatus.getCach(`${storeId}_${user.id}`)?.open} />
						{#if openStatus.getCach(`${storeId}_${user.id}`)?.open}
							<div class="detail-wrapper">
								<div class="accumulate-use">
									<div class="row">
										<span>{$t('global.point.total_accumulate')}</span>
										<p>{user.totalReward}P</p>
									</div>
									<div class="row">
										<span>{$t('global.point.used')}</span>
										<p>{user.totalUsedReward}P</p>
									</div>
								</div>
								<UserUseList storeId={storeId} userId={user.id} />
							</div>
						{/if}
					{/each}
				</div>
			</div>
			<div class="pagenation">
				<Pagenation
					buttonCallback={buttonHandler}
					presentPage={presentPage}
					totalPage={maxpage} />
			</div>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../variables.scss";
	.container {
		.hidden {
			display: none;
		}
		display: flex;
		flex-direction: column;
		gap: 20px;

		.pagenation {
			width: 100%;
			margin-top: 10px;
		}
		.search {
			width: 100%;
			height: 31px;
		}

		.table-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 100%;
			padding: 20px 10px 20px 10px;
			gap: 20px;

			#total-count {
				width: 100%;
				font-size: 1.25rem;
				font-weight: 500;
				color: #46474b;
				text-align: right;
			}
			.table {
				display: flex;
				flex-direction: column;
				width: 100%;
				.header {
					display: none;
				}
				.body {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
				}
			}
		}
		.detail-wrapper {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 100%;
			padding: 18px 10px;
			background-color: #e6e7ed;

			.accumulate-use {
				width: 100%;
				display: flex;
				flex-direction: column;
				gap: 6px;
				.row {
					color: #46474b;
					width: 100%;
					display: flex;
					justify-content: space-between;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			.search {
				width: calc(50% - 15.5px);
				font-size: 1.25rem;
				height: 40px;
			}
			.pagenation {
				margin-top: 0;
			}
			.table-container {
				padding: 30px;
				gap: 30px;
				#total-count {
					font-size: 1.5rem;
				}

				.table {
					display: flex;
					flex-direction: column;
					width: 100%;
					.header {
						display: flex;
						margin-bottom: 10px;
					}
					.col {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 20%;
						max-width: 20%;
						color: #6d6f76;
						font-size: 1.25rem;
					}
				}
			}

			.detail-wrapper {
				padding: 30px;

				.accumulate-use {
					display: none;
				}
			}
		}
	}

</style>
